import { render, staticRenderFns } from "./PlayContainer.vue?vue&type=template&id=08427ec2&scoped=true&"
import script from "./PlayContainer.vue?vue&type=script&lang=js&"
export * from "./PlayContainer.vue?vue&type=script&lang=js&"
import style0 from "./PlayContainer.vue?vue&type=style&index=0&id=08427ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08427ec2",
  null
  
)

export default component.exports